import { STATIC_CONSTANTS } from 'constants/static-constants';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/FormComponents';
import { FormMessage } from 'components/FormComponents/FormMessage/FormMessage';
import SliderMotion from 'components/Motion/SliderMotion';

const CandidateCompleted = () => {
  const { t } = useTranslation();
  return (
    <SliderMotion
      key="success-application"
      duration={0.6}
      delay={0.15}
      className="min-h-screen w-full flex flex-col items-center justify-center p-8 relative gap-8">
      <div className="blob blob-1"></div>
      <div className="w-full md:w-1/2 lg:w-1/3 flex flex-col items-center justify-center gap-8 bg-neutral-1 rounded-3xl p-8 border border-neutral-4 z-10 shadow-2xl shadow-primary-4/20">
        <div
          className="rounded-3xl border border-neutral-4 w-full h-[350px] bg-cover bg-center bg-no-repeat mb-6"
          style={{ backgroundImage: 'url(/assets/images/success-application.jpg)' }}></div>
        <div className="flex flex-col items-center justify-center gap-2">
          <h1 className="text-5xl font-bold text-neutral-7 text-center">
            Application submitted successfully
          </h1>
        </div>
        <FormMessage
          type="Brand"
          message={t('candidate.dashboard.candidateFormCompleted')}
          closeable={false}
          noMargin
        />
        <Button
          type="gradient"
          className="w-full"
          onClick={() => (window.location.href = `${STATIC_CONSTANTS.MARKETING_URL}`)}>
          Go to Checkmate
        </Button>
      </div>
    </SliderMotion>
  );
};

export default CandidateCompleted;
